import React, { Fragment, useEffect, useRef, useState } from "react";

import ReactToPrint from "react-to-print";
import Button from "../../../../component/button/Button";
import Card from "../../../../component/card/Card";
import Starter from "../../../../component/Starter";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearDprErrors,
  clearDprResult,
  getDprDetails,
  setDprLoading
} from "../../../../redux/actions/dprActions";
import moment from "moment";

const DailyDpr = () => {
  const componentRef = useRef();
  const { dpr_id } = useParams();
  const loginType = localStorage.loginType;
  const dispatch = useDispatch();

  const [dprDetailsObject, setDprDetailsObject] = useState({});

  const { dprDetails } = useSelector((state) => state.dpr);

  useEffect(() => {
    console.log(dprDetails);
    if (dprDetails !== null) {
      setDprDetailsObject(dprDetails);
    } else {
      setDprDetailsObject({});
    }
  }, [dprDetails]);

  useEffect(() => {
    dispatch(setDprLoading(true));
    dispatch(clearDprErrors());
    dispatch(clearDprResult());
    dispatch(getDprDetails(dpr_id, loginType));
    return () => {
      dispatch(setDprLoading(true));
      dispatch(clearDprErrors());
      dispatch(clearDprResult());
    };
  }, [dpr_id]);

  return (
    <Starter
      topBarTitle="Daily progress report"
      breadCrumb={
        <Fragment>
          <li className="breadcrumb-item">
            <a href="#">Dpr Module</a>
          </li>
          <li className="breadcrumb-item">
            <a href="#">Report</a>
          </li>
          <li className="breadcrumb-item active">DPR</li>
        </Fragment>
      }
    >
      <Card id="divToPrint" ref={componentRef}>
        <div className="row ml-2 mr-2">
          <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12  pb-2 text-center">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 pt-2 pb-2 side-title">
              Daily Progress Report
            </div>
            <div>
              <div className="logo"></div>
              <div className="h1">CLASSIC MARBLE COMPANY</div>
            </div>
            <div className="h5">
              <div className="date-time">
                Date : -{" "}
                {moment(dprDetailsObject?.createdAt).format(
                  "DD-MM-YYYY"
                )}
              </div>
            </div>
            <div className="break-line col-xl-12 col-lg-12 col-md-12 col-sm-12 "></div>
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 h4 text-left">
              <div className="row mt-3 mb-3 ">
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 ">
                  Project : -
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                  {dprDetailsObject?.locationId?.locationName}
                </div>
              </div>
              <div className="row mt-3 mb-3">
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 ">
                  STATE / CITY : -
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                  {dprDetailsObject?.locationId?.locationState +
                    " / " +
                    dprDetailsObject?.locationId?.locationCity}
                </div>
              </div>
              <div className="row mt-3 mb-3">
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 ">
                  EPC : -
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                  {dprDetailsObject?.locationId?.EPC}
                </div>
              </div>
              <div className="row mt-3 mb-3">
                <div className="col-xl-4 col-lg-4 col-md-4 col-sm-4 ">
                  Report prepared by : -
                </div>
                <div className="col-xl-3 col-lg-3 col-md-3 col-sm-3">
                  {dprDetailsObject?.createdBy?.workerFirstName +
                    " " +
                    dprDetailsObject?.createdBy?.workerSurname}
                </div>
              </div>
            </div>
            <div className="break-line col-xl-12 col-lg-12 col-md-12 col-sm-12 "></div>
            <div className=" col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4 mb-4">
              <div className="table-responsive">
                <table
                  className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
                  id="products-datatable"
                >
                  <thead className="thead-light">
                    <tr>
                      <th>Description</th>
                      <th>Manpower</th>
                      <th>Onsite Assignment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {typeof dprDetailsObject?.workLogField !==
                      "undefined" &&
                      dprDetailsObject?.workLogField !== null &&
                      dprDetailsObject?.workLogField.length > 0 &&
                      dprDetailsObject?.workLogField.map(
                        (val, index) => {
                          return (
                            <tr key={index}>
                              <td>{val?.addDescription}</td>
                              <td>{val?.addManpower}</td>
                              <td>{val?.addOnSiteAssignment}</td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="break-line col-xl-12 col-lg-12 col-md-12 col-sm-12 "></div>
            <div className=" col-xl-12 col-lg-12 col-md-12 col-sm-12 text-left mb-4">
              <div className="h3 ">General Notes</div>
              <div className="notes">
                {dprDetailsObject?.generalNotes}
              </div>
            </div>
            <div className="break-line col-xl-12 col-lg-12 col-md-12 col-sm-12 "></div>
            <div className=" col-xl-12 col-lg-12 col-md-12 col-sm-12 text-left mb-4">
              <div className="h3">Safety-observation</div>
              <div className="notes">
                {dprDetailsObject?.safetyObservation}
              </div>
            </div>
            <div className="break-line col-xl-12 col-lg-12 col-md-12 col-sm-12 "></div>
            <div className=" col-xl-12 col-lg-12 col-md-12 col-sm-12 text-left mb-4">
              <div className="h3 ">Quality Control Observations</div>
              <div className="notes">
                {dprDetailsObject?.qualityControlObservation}
              </div>
            </div>
            <div className="break-line col-xl-12 col-lg-12 col-md-12 col-sm-12 "></div>
            <div className=" col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
              <div className="table-responsive">
                <table
                  className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap"
                  id="products-datatable"
                >
                  <thead className="thead-light">
                    <tr>
                      <th>Questions</th>
                      <th>NO</th>
                      <th>YES</th>
                      <th>N/A</th>
                      <th>Description</th>
                    </tr>
                  </thead>
                  <tbody>
                    {typeof dprDetailsObject?.safetyQuestions !==
                      "undefined" &&
                      dprDetailsObject?.safetyQuestions !== null &&
                      dprDetailsObject?.safetyQuestions.length > 0 &&
                      dprDetailsObject?.safetyQuestions.map(
                        (val, index) => {
                          return (
                            <tr key={index}>
                              <td>{val?.name}</td>
                              <td>
                                <input
                                  type="radio"
                                  checked={val?.status === "YES"}
                                />
                              </td>
                              <td>
                                <input
                                  type="radio"
                                  checked={val?.status === "NO"}
                                />
                              </td>
                              <td>
                                <input
                                  type="radio"
                                  checked={
                                    val?.status === "NOT-AVAILABLE"
                                  }
                                />
                              </td>
                              <td>{val?.description}</td>
                            </tr>
                          );
                        }
                      )}
                  </tbody>
                </table>
              </div>
              <div className="row mt-3">
                {typeof dprDetailsObject?.dprScreenshots !==
                  "undefined" &&
                  dprDetailsObject?.dprScreenshots !== null &&
                  dprDetailsObject?.dprScreenshots.length > 0 &&
                  dprDetailsObject?.dprScreenshots.map(
                    (dprScreenshot, screenShotIndex) => (
                      <div key={screenShotIndex}>
                        <img
                          src={dprScreenshot}
                          className="img-thumbnail mr-2"
                          style={{
                            height: "350px",
                            width: "200px"
                          }}
                        />
                        <br />
                        <a
                          href={dprScreenshot}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Image No {screenShotIndex + 1}
                        </a>
                      </div>
                    )
                  )}
              </div>
            </div>
          </div>
        </div>
      </Card>
      <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 text-center mb-4">
        <ReactToPrint
          trigger={() => (
            <Button
              type="button"
              title="Download"
              isBackgroundColor={false}
              icon="mdi mdi-arrow-collapse-down mr-2"
              className="btn text-white btn-block btn-dark"
            >
              Download
            </Button>
          )}
          content={() => componentRef.current}
          documentTitle={`DPR_${
            dprDetailsObject?.locationId?.locationName
          }_${moment(dprDetailsObject?.createdAt).format(
            "DD-MM-YYYY"
          )}`}
        />
      </div>
    </Starter>
  );
};

export default DailyDpr;
